import PropTypes from "prop-types";

function ProductQuestion({ questionData }) {
  const { customer_name, question, answer, date } = questionData;

  return (
    <article>
      <small className="mb-[1.313rem] block text-[0.875rem] text-grayDisplay-850">
        By<span className="text-tertiary">&nbsp; {customer_name} &nbsp;</span>
        {date}
      </small>

      <div className="mb-[1.313rem] flex items-start space-x-[0.75rem] font-semibold text-grayDisplay-700 lg:space-x-[1.125rem]">
        <p>Question:</p>
        <p className="break-all">{question}</p>
      </div>

      <div className="flex items-start space-x-[1.438rem] text-grayDisplay-700 lg:space-x-[1.813rem]">
        <p className="font-medium">Answer:</p>
        <div dangerouslySetInnerHTML={{ __html: answer }} />
      </div>
    </article>
  );
}

ProductQuestion.propTypes = {
  questionData: PropTypes.shape({
    user: PropTypes.string,
    question: PropTypes.string,
    answer: PropTypes.string,
  }),
};

export default ProductQuestion;
